<template>
    <dx-text-box :value="value" :read-only="true" />
</template>
<script setup>
import { DxTextBox } from 'devextreme-vue';

defineProps({
    value: {
        default: '',
        required: true,
        type: [String, Number, null],
    },
});
</script>
